/**
 * Include polyfills as global
 * (https://github.com/taylorhakes/promise-polyfill#simple-use)
 */ 
import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';